export default (hashid, reminderFee = false) => {
  const add = reminderFee ? `&with_reminder=${reminderFee}` : '';
  const url = `${process.env.API_LOCATION}/invoices/${hashid}/?token=${localStorage.getItem('id_token')}${add}`;
  window.open(url);
};



// WEBPACK FOOTER //
// ./src/app/services/invoice/show.js